import { Injectable } from '@angular/core';
import { RestApiService } from '../rest-api/rest-api.service';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class NavigationMockService {
    public loaded$: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public navigationObj$: BehaviorSubject<Array<any>> = new BehaviorSubject(null);
    public fullNavigation$: BehaviorSubject<any> = new BehaviorSubject(null);
    public footerObj$: BehaviorSubject<Array<any>> = new BehaviorSubject(null);
    public fullNavigationData: any = <any>{};
    private navigationData: Array<any> = [];
    private footerData: Array<any> = [];
    private _site: string;

    constructor(private _restApi: RestApiService) {
        this._site = 'en_uk';
    }

    async _loadAllNavigationData(): Promise<boolean> {
        const _url = '/assets/mock/navigation_data.json';
        return this._restApi.requestGET<any>(_url).then(
            (data: any) => {
                this.fullNavigationData = data.Navigation;
                this.navigationData = data.Navigation.Children.filter((item) => !item.IsHidden);
                this.footerData = data.Footer.Children;
                this._publishNavigationData();
                return true;
            },
            () => {
                return false;
            }
        );
    }

    private _publishNavigationData() {
        this.loaded$.next(true);
        this.fullNavigation$.next(this.fullNavigationData);
        this.navigationObj$.next(this.navigationData);
        this.footerObj$.next(this.footerData);
    }
}
